import { ChevronRightIcon } from "@heroicons/react/20/solid";
import {
  PhoneArrowUpRightIcon,
  QuestionMarkCircleIcon,
  ShoppingCartIcon,
} from "@heroicons/react/24/outline";
import {
  BookmarkSquareIcon,
  BookOpenIcon,
  QueueListIcon,
  RssIcon,
} from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import Logo from "../../components/images/LOGO.png";

const links = [
  {
    name: "Kontakt Oss",
    href: "/kontakt",
    description: "Kontaktinformasjon",
    icon: PhoneArrowUpRightIcon,
  },
  {
    name: "Produkter",
    href: "/produkter",
    description: "Se alle våre produkter",
    icon: ShoppingCartIcon,
  },
  {
    name: "Om Oss",
    href: "/om-oss",
    description: "Alt du trenger å vite om oss",
    icon: BookOpenIcon,
  },
  {
    name: "Hjelp",
    href: "/hjelp",
    description: "Vanlige spørsmål og artikler om ventilasjon og service",
    icon: QuestionMarkCircleIcon,
  },
];

export const PageUnderDevelopment = () => {
  return (
    <div className="mx-auto w-full max-w-7xl px-6 pb-16 sm:pb-24 lg:px-8">
      <div className="mx-auto mt-20 max-w-2xl text-center sm:mt-24">
        <p className="text-base font-semibold leading-8 text-blue-400">
          Side under utvikkling
        </p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Siden kommer snart...
        </h1>
        <p className="mt-4 text-base leading-7 text-gray-600 sm:mt-6 sm:text-lg sm:leading-8">
          Vi holder fortsatt på med utvikklingen av vår nye nettside
        </p>
      </div>
      <div className="mx-auto mt-16 flow-root max-w-lg sm:mt-20">
        <h2 className="sr-only">Populære sider</h2>
        <ul
          role="list"
          className="-mt-6 divide-y divide-gray-900/5 border-b border-gray-900/5"
        >
          {links.map((link, linkIdx) => (
            <li key={linkIdx} className="relative flex gap-x-6 py-6">
              <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg shadow-sm ring-1 ring-gray-900/10">
                <link.icon
                  className="h-6 w-6 text-blue-400"
                  aria-hidden="true"
                />
              </div>
              <div className="flex-auto">
                <h3 className="text-sm font-semibold leading-6 text-gray-900">
                  <a href={link.href}>
                    <span className="absolute inset-0" aria-hidden="true" />
                    {link.name}
                  </a>
                </h3>
                <p className="mt-2 text-sm leading-6 text-gray-600">
                  {link.description}
                </p>
              </div>
              <div className="flex-none self-center">
                <ChevronRightIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </div>
            </li>
          ))}
        </ul>
        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="text-sm font-semibold leading-6 text-blue-400"
          >
            <span aria-hidden="true">&larr;</span>
            Tilbake til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
};
